/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Developer_SubtitleInputs */



/**
* | output |
* | --- |
* | "Manage your OAuth applications" |
*
* @param {Developer_SubtitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const developer_subtitle = /** @type {((inputs?: Developer_SubtitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Developer_SubtitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Gérez vos applications OAuth")
	if (locale === "es") return /** @type {LocalizedString} */ ("Gestione sus aplicaciones OAuth")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Gerencie seus aplicativos OAuth")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gestisci le tue applicazioni OAuth")
	return /** @type {LocalizedString} */ ("Manage your OAuth applications")
});